import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";

import {Box, Flex} from 'rebass';
import moment from 'moment'
import {sortBy} from 'lodash-es'

import {LeavesCard} from '../../components/Cards'
import {TableHorizontalScroll} from "./styles";
import LeavesTable from './LeavesTable'
import {schoolSelectors} from "../../store/school";
import {leavesActions, leavesSelectors} from "../../store/leaves";


class AirportTab extends Component {
	constructor(props) {
		super(props);
		this.state = {width: 0, height: 0, range: 'all'};
		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
	}

	componentDidMount() {
		this.updateWindowDimensions();
		window.addEventListener('resize', this.updateWindowDimensions);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions);
	}

	updateWindowDimensions() {
		this.setState({width: window.innerWidth, height: window.innerHeight});
	}

	filterLeaves = (unSortedLeaves, type, range) => {
		const day = moment().day()
		const daysLeft = 7 - day
		let leaves = [];
		if(type === "Returning")
			leaves = sortBy(unSortedLeaves, 'end_date', 'asc');
		else
			leaves = sortBy(unSortedLeaves, 'start_date', 'asc');
		switch (range) {
			case 'missed':
				if ((type === "Returning")) {

					return leaves.filter(item => moment.unix(item.end_date).isBefore(Date.now()));
				} 
				else if (type === "Declined") {
					return leaves.filter(item => moment.unix(item.start_date).isAfter(Date.now()));
				}
				else {
					return leaves.filter(item => moment.unix(item.start_date).isBefore(Date.now()));

				}

			case 'pending':
				if (type === 'Returning') {
					return leaves.filter(item => moment.unix(item.end_date).isAfter(Date.now()));

				} else if (type === "Declined") {
					return leaves.filter(item => moment.unix(item.start_date).isBefore(Date.now()));
				}
				else {
					return leaves.filter(item => moment.unix(item.start_date).isAfter(Date.now()));

				}
			case 'today':
				if (type === 'Returning') {
					return leaves.filter(item => moment.unix(item.end_date).isAfter(Date.now()) && moment.unix(item.end_date).isBefore((Date.now() + (24 * 60 * 60 * 1000)), 'day'));

				} else {
					return leaves.filter(item => moment.unix(item.start_date).isAfter(Date.now()) && moment.unix(item.start_date).isBefore((Date.now() + (24 * 60 * 60 * 1000)), 'day'));

				}
			case 'tomorrow':
				if (type === 'Returning') {
					return leaves.filter(item => moment.unix(item.end_date).isSame((Date.now() + (24 * 60 * 60 * 1000)), 'day'));

				} else {
					return leaves.filter(item => moment.unix(item.start_date).isSame((Date.now() + (24 * 60 * 60 * 1000)), 'day'));

				}
			case 'week':
				if (type === 'Returning') {
					return leaves.filter(item => (moment.unix(item.end_date).isSameOrAfter((Date.now() + 2 * (24 * 60 * 60 * 1000)), 'day')) && moment.unix(item.end_date).isBefore((Date.now() + daysLeft * (24 * 60 * 60 * 1000)), 'day'));

				} else {
					return leaves.filter(item => (moment.unix(item.start_date).isSameOrAfter((Date.now() + 2 * (24 * 60 * 60 * 1000)), 'day')) && moment.unix(item.start_date).isBefore((Date.now() + daysLeft * (24 * 60 * 60 * 1000)), 'day'));

				}
			case 'later':
				if (type === 'Returning') {
					return leaves.filter(item => (moment.unix(item.end_date).isAfter((Date.now() + daysLeft * (24 * 60 * 60 * 1000)), 'day')));

				} else {
					return leaves.filter(item => (moment.unix(item.start_date).isAfter((Date.now() + daysLeft * (24 * 60 * 60 * 1000)), 'day')));

				}
			default:
				return leaves
		}
	};

	renderTabletView = () => {
		const {width} = this.state;
		if (width < 750) {
			return true
		}
		return false;
	};

	setMobileRange = (range) => {
		this.setState({range})
	};

	render() {
		const {type, leaves, types, missedFilters, pendingFilters, updateMissedFilter, clearMissedFilter, updatePendingFilter, clearPendingFilter, profile} = this.props;
		const {width, range} = this.state;

		const mobileLeaves = this.filterLeaves(leaves, type, range);

		const pending = this.filterLeaves(leaves, type, 'pending')
		const missed = this.filterLeaves(leaves, type, 'missed');
		return (
			<Box p={2} pt={width < 700 && width > 650 ? 4 : 0}>

				{/* If mobile, display Date filters, else display Missed scrollable feed*/}
				{width < 800 ?
					// mobile version
					<Flex flexDirection={['column']} flexWrap={'wrap'} width={1} p={2} pb={5} m={0}>
						{mobileLeaves.map(item => (

								<LeavesCard key={item.id} details={item}
											isAdmin={profile && profile.is_admin}
											type={type}
								            missed={(type === 'Returning') ? moment.unix(item.end_date).isBefore(Date.now()) : moment.unix(item.start_date).isBefore(Date.now())}
								            variant='leaves'
								            types={types}/>

							)
						)}
					</Flex>
					:
					<Box>
						<Fragment>


							<TableHorizontalScroll flexDirection={['column']} flexWrap={'wrap'} width={1} pt={2} px={1} m={0}
							                       pb={'400px'} mb={2}>
								{missed.length > 0 &&
								<Box pb={pending.length > 0 ? 5 : 0}>
									<LeavesTable
										profile={profile}
										types={types}
										type={type}
										leaves={missed}
										title={'Missed'}
										filters={missedFilters}
										isAdmin={profile && profile.is_admin}
										handleUpdateFilter={updateMissedFilter}
										handleClearFilter={clearMissedFilter}
									/>
								</Box>
								}

								{pending.length > 0 &&
								<Box width={1} pb={'55px'}>
									<LeavesTable
										profile={profile}
										types={types}
										type={type}
										leaves={pending}
										title={'Others'}
										filters={pendingFilters}
										isAdmin={profile && profile.is_admin}
										handleUpdateFilter={updatePendingFilter}
										handleClearFilter={clearPendingFilter}
									/>

								</Box>
								}


							</TableHorizontalScroll>
						</Fragment>
					</Box>
				}


			</Box>
		)
	}
}

function mapStateToProps(state) {
	return {
		schoolInfo: schoolSelectors.refreshSchool(state.school),
		loadingSchool: schoolSelectors.isLoading(state.school),
		missedFilters: leavesSelectors.refreshMissedFilter(state.leaves),
		pendingFilters: leavesSelectors.refreshPendingFilter(state.leaves)
	};
}

const mapDispatchToProps = (dispatch) => ({
	updateMissedFilter: (filters) => dispatch(leavesActions.updateMissedFilter(filters)),
	clearMissedFilter: () => dispatch(leavesActions.clearMissedFilter()),
	updatePendingFilter: (filters) => dispatch(leavesActions.updatePendingFilter(filters)),
	clearPendingFilter: () => dispatch(leavesActions.clearPendingFilter())
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AirportTab)

